var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"bg-purple"},[_c('form-build-component',{attrs:{"form-name":"customerForm","form-data":_vm.customerForm,"form-columns-group":_vm.customerFormColumnsGroup,"form-rules":_vm.customerFormRules,"form-buttons":_vm.customerFormButtons}})],1),_vm._v(" "),_c('button-back')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-516c880a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/lender/CustomerAdmin/CustomerEdit.vue
// module id = null
// module chunks = 